<template>
    <div class="certificationPass">
        <el-alert
            v-if="data.is_apply !== 5"
            title="认证通过"
            :closable="false"
            type="success">
        </el-alert>

        <div class="title">一、填写认证信息</div>
        <el-form :model="ruleForm"  ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="企业名称:" prop="corporate_name">
                        {{ ruleForm.corporate_name }}
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="企业类型:" prop="corporate_type">
                        {{ ruleForm.corporate_type }}
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="企业法人:" prop="legal_person">
                        {{ ruleForm.legal_person }}
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="法人身份证:" prop="legal_person_card_id">
                        {{ ruleForm.legal_person_card_id }}
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="22">
                    <el-form-item label="法人身份证过期时间:" prop="legal_person_card_id">
                        {{ ruleForm.legal_person_card_id_expires_time }}
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="公司联系人:" prop="contacts">
                        {{ ruleForm.contacts }}
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="联系人手机:" prop="mobile">
                        {{ ruleForm.mobile }}
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="固定电话:" prop="tel_phone">
                        {{ ruleForm.tel_phone !== '' ? ruleForm.tel_phone : '未填写'}}
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="所在地区:" required>
                {{ ruleForm.area }}
            </el-form-item>
            <el-form-item label="详细地址：" prop="address">
                {{ ruleForm.address }}
            </el-form-item>
            
           
        </el-form>
        <div class="title">二、上传资质信息</div>
        <div class="PS">
            请添加药品经营许可证、GSP证、营业执照、质保书、采购&收货授权委托书、身份证复印件、组织机构代码证税务登记证、医疗机构许可证
        </div>
        <div class="imgBox">
            <div class="contentItem" v-for="(item,key) in partTwo" :key="key">
                <div class="itemtitle">
                    {{item.name}}
                </div>
                <div class="itemContent">
                    <div class="itemtitle">
                        有效期至：{{item.time}}
                    </div>
                    <el-image
                        v-if="item.type === 'image'"
                        style="width: 300px; height: 300px"
                        :src="item.value"
                        :preview-src-list="[item.value]">
                    </el-image>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const formFieldsImages = [
  { type: 'image', key: 'management_license', label: '药品经营许可证', limit: 1, span: 6 },
  { type: 'date', key: 'management_license_expires_time', label: '药品经营许可证有效期', height: '190px', span: 6 },
  { type: 'image', key: 'business_license', label: '营业执照', limit: 1, span: 6 },
  { type: 'date', key: 'business_license_expires_time', label: '营业执照有效期', height: '190px', span: 6 },
  { type: 'image', key: 'gps_license', label: '	GPS证', limit: 1, span: 6 },
  { type: 'date', key: 'gps_license_expires_time', label: 'GPS证有效期', height: '190px', span: 6 },
  { type: 'image', key: 'warranty_book', label: '质保书', limit: 1, span: 6 },
  { type: 'date', key: 'warranty_book_expires_time', label: '质保书有效期', height: '190px', span: 6 },
  { type: 'image', key: 'authorised_letter', label: '采购&收货授权委托书', limit: 1, span: 6 },
  { type: 'date', key: 'authorised_letter_expires_time', label: '采购&收货授权委托书有效期', height: '190px', span: 6 },
  { type: 'image', key: 'id_copy', label: '需附身份证复印件', limit: 1, span: 6 },
  { type: 'date', key: 'id_copy_expires_time', label: '需附身份证复印件有效期', height: '190px', span: 6 },
  { type: 'image', key: 'tax_certificate', label: '组织机构代码证税务登记证', limit: 1, span: 6 },
  { type: 'date', key: 'tax_certificate_expires_time', label: '组织机构代码证税务登记证有效期', height: '190px', span: 6 },
  { type: 'image', key: 'medical_license', label: '医疗机构许可证', limit: 1, span: 6 },
  { type: 'date', key: 'medical_license_expires_time', label: '医疗机构许可证有效期', height: '190px', span: 6 },
];
export default {
    props: [ 'data' ],
    data() {
        return {
            province: [],
            city: [],
            district: [],
            twon: [],
            fileList: [],
            ruleForm: {
                province: '',
                city:'',
                district:'',
                twon:'',
            },
            partTwo: {},
        }
    },
    methods: {
    },
    created() {
        this.ruleForm = JSON.parse(JSON.stringify(this.data))
        for (const key of Object.keys(this.ruleForm)) {
            const foundItem = (formFieldsImages.find(item => item.key === key) || {})
            if (foundItem.type === 'image') {
                this.partTwo[key] = {
                    type: 'image',
                    name: foundItem.label,
                    value: this.ruleForm.base_url + this.ruleForm[key]
                };
            } else if(foundItem.type === 'date') {
                this.partTwo[key] = {
                    name: foundItem.label,
                    value: this.ruleForm[key]
                };
            }
        }
        let temp = {}
        for(let i in this.partTwo){
            if(i.substr(i.length-13,13)==='_expires_time'){
                temp[i.substr(0,i.length-13)].time = this.partTwo[i].value
            }else{
                temp[i] = this.partTwo[i]
            }
        }
        this.partTwo = JSON.parse(JSON.stringify(temp))
    }
}
</script>

<style lang="scss" scoped>
    .title{
        font-size: 15px;
        font-weight: 700;
        margin-top: 60px;
    }
    .PS{
        width: 90%;
        font-size: 14px;
        border: 1px solid #b9b9b9;
        border-radius: 2px;
        padding: 15px;
        margin: 60px auto;

    }
    .certificationPass{
        min-height: 2448px;
    }
    .imgBox{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        text-align: center;
        .imgItem{
            display: flex;
            flex-direction: column;
            height: 450px;
            img{
                width: 200px;
                height: 200px;
            }
        }
    }
    .contentItem {
        width: 50%;
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        .itemtitle {
            font-size: 16px;
        }
        .itemContent {
            font-size: 18px;
            font-weight: bold;
        }
        img {
            height: 100px;
            width: 100px;
        }
    }
</style>

<style lang="scss">
    .uploadDisplay .el-upload--picture-card{
        display: none;
    }
</style>